import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";

import type { ExerciseItem } from "api/services/content/schemas/exercises";
import { useApiClient } from "api/useApiClient";

export const queryKeyPrefix = "getExercise";
type QueryKey = [typeof queryKeyPrefix, number, string?];
export const getExerciseQueryKey = (exerciseID: number, locale: string): QueryKey => [
  "getExercise",
  exerciseID,
  locale,
];

export const useGetExercise = (
  exerciseID: number,
  locale: string,
  options?: UseQueryOptions<ExerciseItem, Error, ExerciseItem, QueryKey>
) => {
  const client = useApiClient();

  return useQuery(getExerciseQueryKey(exerciseID, locale), () => client.getExercise(exerciseID, locale), options);
};
